import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, CheckboxRequiredValidator } from '@angular/forms';
import { SelectBox, TimeApiService, UsedSgkz011aService } from 'cbc-shared-lib';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  ResponseCommon, Sgkz011aResponseUserOrganizationDto,
  Sgkb702aRequest, Sgkb702aResponse,
  Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto,
  CodeConversionMstDto,
  Sgkb991aRequest,
  Sgkb991aResponse,
  Sgkb991aResBushoInfoDto,
  Sgkb992aRequest,
  Sgkb992aResponse,
  Sgkb992aResStaffInfoDto
} from 'sg-api';
import { UsedSgkb702aService } from '../../services/used-sgkb702a.service';
import { UsedSgkb991aService } from '../../services/used-sgkb991a.service';
import { UsedSgkb992aService } from '../../services/used-sgkb992a.service';

@Component({
  selector: 'app-sgkb701d-search-condition',
  templateUrl: './sgkb701d-search-condition.component.html',
  styleUrl: './sgkb701d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [],
})

export class Sgkb701dSearchConditionComponent implements OnInit, OnDestroy {

  /** 遷移元ステータス */
  @Input() mode: string;

  /** ボタン押下イベント */
  @Output() onClickButtonEvent =
    new EventEmitter<{
      showResult: boolean; clearExeFlg: boolean;
      incCtrSearchResultList: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto
    }>();

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;;
  /** 検索情報格納FormGroup*/
  kensakuJyoukenChild: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 契約担当部署 */
  keiyakuTantouBushoCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当者個別入力チェックボックス */
  keiyakuTantouCheckBox: UntypedFormControl =
    this.fb.control({ value: false, disabled: false });
  /** 契約担当者（リスト） */
  keiyakuTantousyaCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当者（テキスト） */
  keiyakuTantousyaTxt: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括お客さま番号 */
  houkatsuOkyakusamaNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括お客さま名 */
  houkatsuOkyakusamaName: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 申請状況 */
  shinseiJoukyouCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約終了日（開始） */
  keiyakuManryouYMDFrom: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約終了日（終了） */
  keiyakuManryouYMDTo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 過去契約も含むチェックボックス */
  kakokeiyakuCheckBox: UntypedFormControl =
    this.fb.control({ value: false, disabled: false });

  /** 契約担当者個別入力チェック */
  keiyakuTantousyaFlg: boolean = false;

  // ユーザ組織情報
  userOrganizationInfo: Sgkz011aResponseUserOrganizationDto = {
    sosikiId: '',
    sosikiName: '',
    comgrpcd: '',
    comCode: '',
    topSosikiId: '',
    areaCd: '',
    kyotenHyojiFlg: '',
    cmpnyName: '',
  };
  // ユーザーID
  usrId: string = "";

  // 部署コード
  bushoCode: string = "";

  /** 契約担当部署リスト情報 */
  keiyakuTantouBushoList: SelectBox[] = [];

  /** 契約担当者リスト情報 */
  keiyakuTantousyaList: SelectBox[] = [];

  /** 包括契約、包括対象需給契約検索結果 */
  sgkb702aResponse: Sgkb702aResponse;
  /** responseCommon(SGKB702A) */
  sgkb702aResponseCommon: ResponseCommon;
  /** 包括契約情報 */
  incCtrSearchResultList: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;

  /** 部署情報検索結果 */
  sgkb991aResponse: Sgkb991aResponse;
  /** responseCommon(SGKB991A) */
  sgkb991aResponseCommon: ResponseCommon;
  /** 部署情報リスト */
  bushoInfoList: Array<Sgkb991aResBushoInfoDto>;

  /** 社員情報検索結果 */
  sgkb992aResponse: Sgkb992aResponse;
  /** responseCommon(SGKB992A) */
  sgkb992aResponseCommon: ResponseCommon;
  /** 社員情報リスト */
  staffInfoList: Array<Sgkb992aResStaffInfoDto>;

  /** 画面項目の編集変数 */
  /** コード一覧 */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** コード変換マスタから受け取る包括契約申請状況コードのリスト */
  preShinseiJoukyouList: SelectBox[] = [];
  /** 申請状況のセレクトボックスデータ */
  shinseiJoukyouList: SelectBox[] = [];

  /**
   * コンストラクタ
   * @memberof Sgkb701dSearchConditionComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private timeApiService: TimeApiService,
    private codeConversionMstService: CodeConversionMstService,
    private usedSgkb702aService: UsedSgkb702aService,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSgkb991aService: UsedSgkb991aService,
    private usedSgkb992aService: UsedSgkb992aService
  ) { }

  /**
   * 購読を停止する処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('kensakuJyoukenChild');
  }

  /**
   * 初期表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  ngOnInit(): void {
    // ユーザー情報等を更新
    this.usedSgkz011aService.updateUserInfo();
    // ユーザ情報取得
    this.usedSgkz011aService.userOrganizationInfo
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(userOrganizationInfo => {
        this.userOrganizationInfo = userOrganizationInfo;
      });
    this.usedSgkz011aService.userId
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(userId => {
        this.usrId = userId;
      });

    this.kensakuJyoukenChild = this.fb.group({
      keiyakuTantouBushoCategory: this.keiyakuTantouBushoCategory,
      keiyakuTantouCheckBox: this.keiyakuTantouCheckBox,
      keiyakuTantousyaCategory: this.keiyakuTantousyaCategory,
      keiyakuTantousyaTxt: this.keiyakuTantousyaTxt,
      houkatsuOkyakusamaNo: this.houkatsuOkyakusamaNo,
      houkatsuOkyakusamaName: this.houkatsuOkyakusamaName,
      shinseiJoukyouCategory: this.shinseiJoukyouCategory,
      keiyakuManryouYMDFrom: this.keiyakuManryouYMDFrom,
      keiyakuManryouYMDTo: this.keiyakuManryouYMDTo,
      kakokeiyakuCheckBox: this.kakokeiyakuCheckBox,
    });
    //親と子の紐づけを行う
    this.parentForm = this.parent.form;
    this.parentForm.addControl('kensakuJyoukenChild', this.kensakuJyoukenChild);

    // 部署情報取得レスポンスを取得
    this.usedSgkb991aService.searchContractor(this.setSgkb991aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb991aResponseCommon = response.responseCommon;
        this.bushoInfoList = response.bushoInfoList;
        // 契約担当部署リスト情報を初期化する
        this.keiyakuTantouBushoList = [];

        /** 契約担当部署リスト情報 */
        this.bushoInfoList.forEach(data => {
          const select: SelectBox = { value: data.bushoCode, viewValue: data.departmentName };
          this.keiyakuTantouBushoList.push(select);
        })

        // ログイン部署で契約担当部署を選択
        this.kensakuJyoukenChild.controls['keiyakuTantouBushoCategory'].setValue(this.userOrganizationInfo.sosikiId)
      })

    // 社員情報取得レスポンスを取得
    this.bushoCode = this.userOrganizationInfo.sosikiId;
    this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb992aResponseCommon = response.responseCommon;
        this.staffInfoList = response.staffInfoList;
        // 契約担当者リスト情報を初期化する
        this.keiyakuTantousyaList = [];

        /** 契約担当者リスト情報 */
        this.staffInfoList.forEach(data => {
          const select: SelectBox = { value: data.staffCode, viewValue: data.staffName };
          this.keiyakuTantousyaList.push(select);
        })

        // 承認画面以外からの遷移の場合
        if (this.mode != 'approve') {
          // ログイン担当者で契約担当者を選択
          this.kensakuJyoukenChild.controls['keiyakuTantousyaCategory'].setValue(this.usrId)
        } else {
          // ログイン担当者で契約担当者を選択
          this.kensakuJyoukenChild.controls['keiyakuTantousyaCategory'].setValue(null)
        }
      })




    this.codeConversionMstService.getCodeConversionMst([
      "S001170",// 包括契約申請状況コード
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.codeConversionMstMap = data;
        // 停止時要配慮フラグのセレクトボックスデータ生成
        this.preShinseiJoukyouList = this.getSelectBoxFromCodeConversionMst("S001170");
        this.shinseiJoukyouList = this.setSelectBoxData(
          this.shinseiJoukyouCategory.value,
          this.preShinseiJoukyouList);

        // 承認画面 または 取消画面からの遷移の場合
        if (this.mode == 'approve'
          || this.mode == 'delete') {
          // 申請状況の「申請中」を選択
          this.shinseiJoukyouCategory.setValue('1');
        } else {
          // 申請状況の「空白」を選択
          this.shinseiJoukyouCategory.setValue('');
        }

      });

    // 受信データの購読設定（契約情報）
    this.usedSgkb702aService.incCtrSearchChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb702aResponse = response;
        this.sgkb702aResponseCommon = response.responseCommon;
        this.incCtrSearchResultList = response.inclusioncontractInclutagsupdemandctrSearchresult;
      });
  }

  /**
   * 検索押下処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onClickSearch(): void {
    // 包括契約検索レスポンスを取得
    this.usedSgkb702aService.searchContractor(this.setSgkb702aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb702aResponseCommon = response.responseCommon;
        this.incCtrSearchResultList = response.inclusioncontractInclutagsupdemandctrSearchresult;

        // 検索結果がある場合のみ処理を実行
        if (this.incCtrSearchResultList != null) {
          // showResult：検索押下フラグ、clearExeFlg：クリア押下フラグ
          this.onClickButtonEvent.emit({
            showResult: true,
            clearExeFlg: false,
            incCtrSearchResultList: this.incCtrSearchResultList
          });
        }
      });

  }

  /**
   * クリア押下処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onClickClear(): void {
    // 自フォームグループをクリア
    this.kensakuJyoukenChild.reset();
    // 契約担当者個別入力チェックをクリア
    this.keiyakuTantousyaFlg = false;
    // showResult：検索押下フラグ、clearExeFlg：クリア押下フラグ
    this.onClickButtonEvent.emit({
      showResult: false,
      clearExeFlg: true,
      incCtrSearchResultList: null
    });
  }

  /**
   * 契約担当者表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onChangeCheckBox(event: boolean): void {
    switch (event) {
      // 契約担当者個別入力チェックボックス 選択時：契約担当者（テキスト）表示
      case true:
        this.keiyakuTantousyaFlg = true;
        break;
      // 契約担当者個別入力チェックボックス 未選択時：契約担当者（リスト）表示
      case false:
        this.keiyakuTantousyaFlg = false;
        break;
      default:
        break;
    }
  }

  /**
   * 契約担当者リスト表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onChangeSelectBox(event: any): void {
    // 社員情報取得レスポンスを取得
    this.bushoCode = event.value
    if (this.bushoCode != null
      && this.bushoCode != "") {
      this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest())
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(response => {
          this.sgkb992aResponseCommon = response.responseCommon;
          this.staffInfoList = response.staffInfoList;
          this.keiyakuTantousyaList = [];
          /** 契約担当者リスト情報 */
          this.staffInfoList.forEach(data => {
            this.keiyakuTantousyaList = this.staffInfoList.map(data =>
            ({
              value: data.staffCode,
              viewValue: data.staffName
            }));
          });
        })
    } else {
      this.keiyakuTantousyaList = null;
    }
    // 検索後は何も選択されていない状態にする
    this.kensakuJyoukenChild.controls['keiyakuTantousyaCategory'].setValue(null)
  }

  /**
   * セレクトボックスの自動生成
   * @memberof Sgkb701dSearchConditionComponent
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let SelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          SelectBoxList.push(select);
        })
      }
    }
    return SelectBoxList;
  }

  /** 
   * セレクトボックスの初期選択値を設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setSelectBoxData(target: string, codeList: Array<SelectBox>): SelectBox[] {

    let selectBox: SelectBox[]

    selectBox = codeList.map(data => ({
      value: data.value,
      viewValue: data.viewValue,
    }))
    return selectBox;
  }

  /**
   * 包括契約検索のリクエスト設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setSgkb702aRequest(): Sgkb702aRequest {
    let ctrTntshNoVal: string = null;
    let ctrTntshVal: string = null;
    // 契約担当者個別入力がチェックありの場合
    if (this.keiyakuTantouCheckBox.value === true) {
      // 契約担当者
      ctrTntshVal = this.keiyakuTantousyaTxt.value;
    }
    // 契約担当者個別入力がチェックなしの場合
    else {
      // 契約担当者番号
      ctrTntshNoVal = this.keiyakuTantousyaCategory.value;
    }

    let kakoCtrContainVal: string = null;
    // 過去契約も含むがチェックありの場合
    if (this.kakokeiyakuCheckBox.value === true) {
      // 過去契約も含む
      kakoCtrContainVal = "1";
    }
    // 過去契約も含むがチェックなしの場合
    else {
      // 過去契約も含む
      kakoCtrContainVal = "0";
    }

    let ctrEnddtStartVal: string = null;
    // 契約終了日（開始）の入力データがある場合
    if (this.keiyakuManryouYMDFrom.value != null
      && this.keiyakuManryouYMDFrom.value != "") {
      // 契約終了日（開始）
      ctrEnddtStartVal = this.timeApiService.convertDateToString(
        new Date(this.keiyakuManryouYMDFrom.value));
    }

    let ctrEnddtEndVal: string = null;
    // 契約終了日（終了）の入力データがある場合
    if (this.keiyakuManryouYMDTo.value != null
      && this.keiyakuManryouYMDTo.value != "") {
      ctrEnddtEndVal = this.timeApiService.convertDateToString(
        new Date(this.keiyakuManryouYMDTo.value));
    }

    // 包括契約検索リクエストを作成
    const sgkb702aRequest: Sgkb702aRequest = {
      inclusioncontractSearchInfo: {
        // 契約担当部署
        ctrTantobushoNo: this.keiyakuTantouBushoCategory.value,
        // 契約担当者番号
        ctrTntshNo: ctrTntshNoVal,
        // 契約担当者
        ctrTntsh: ctrTntshVal,
        // 包括お客さま番号
        inclusioncontractVisitornumber: this.houkatsuOkyakusamaNo.value,
        // 包括お客さま名
        inclusioncontractVisitormei: this.houkatsuOkyakusamaName.value,
        // 申請状況
        appJokyo: this.shinseiJoukyouCategory.value,
        // 契約終了日（開始）
        ctrEnddtStart: ctrEnddtStartVal,
        // 契約終了日（終了）
        ctrEnddtEnd: ctrEnddtEndVal,
        // 過去契約も含む
        kakoCtrContain: kakoCtrContainVal,
        // 包括契約履歴番号
        inclusioncontractRrkno: null,
        // 包括契約年度内通番号
        inclusioncontractYearnaiSrno: null,
      }
    };
    return sgkb702aRequest;
  }

  /**
  * 部署情報検索のリクエスト設定
  * @memberof Sgkb701dSearchConditionComponent
  */
  setSgkb991aRequest(): Sgkb991aRequest {
    // 部署情報検索リクエストを作成
    const sgkb991aRequest: Sgkb991aRequest = {
      companyInfo: {
        // 会社グループコード
        companyGroupCode: this.userOrganizationInfo.comgrpcd,
        // 会社コード
        companyCode: this.userOrganizationInfo.comCode
      }
    }
    return sgkb991aRequest;
  }

  /**
   * 社員情報検索のリクエスト設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setSgkb992aRequest(): Sgkb992aRequest {
    // 社員情報検索リクエストを作成
    const sgkb992aRequest: Sgkb992aRequest = {
      bushoInfo: {
        // 部署コード
        bushoCode: this.bushoCode,
      }
    }
    return sgkb992aRequest;
  }
}
